export default __webpack_public_path__ + "static/media/dev-github.9516c345.svg";